import { render } from "./SetpwdView.vue?vue&type=template&id=23cff37c&scoped=true&ts=true"
import script from "./SetpwdView.vue?vue&type=script&lang=ts"
export * from "./SetpwdView.vue?vue&type=script&lang=ts"

import "./SetpwdView.vue?vue&type=style&index=0&id=23cff37c&lang=less&scoped=true"
import "./SetpwdView.vue?vue&type=style&index=1&id=23cff37c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cff37c"]])

export default __exports__